import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_effect } from '@/hooks/_base/use_effect';
import { use_slice_generation, use_slice_images } from '@/hooks/store/use_slices';
import { LOCAL__images_add_to_loading_pool } from '@/state/images/load/LOCAL__images_add_to_loading_pool';
import { FIELD__image_asset } from '@shared/dto/generation/graph_invoke/_fields/image/FIELD__image_asset';

export function WATCHER_IMAGES__add_to_loading_pool_from_generation_current_graph() {
  /*
   * STORE
   */
  const dispatch = use_dispatch();

  const { images_map } = use_slice_images(['images_map']);
  const { generation_current } = use_slice_generation(['generation_current']);

  /*
   * EFFECTS
   */

  use_effect(() => {
    if (generation_current.is_stub()) return;

    let fields = generation_current.tool.graph.fields__get_by_type(FIELD__image_asset);
    fields = fields.filter(field => !field.is_stub()); //skip stubs
    fields = fields.filter(field => !field.image__is_initialized); //skip already initialized
    fields = fields.filter(field => !field.hash_sha256_content.is_empty_hash_sha256()); //skip empty

    let hashes_to_load: string[] = [];

    for (let field of fields) hashes_to_load.push(field.hash_sha256_content);

    dispatch(LOCAL__images_add_to_loading_pool(hashes_to_load));
  }, [generation_current, images_map]);

  return null;
}
